module.exports = __webpack_public_path__ + "static/media/15.5cc72781.png";